// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * 
 */
enum Type {
    WAITING = 'WAITING', 
    SIGNED = 'SIGNED', 
    APPROVED = 'APPROVED', 
    REJECTED = 'REJECTED', 
    ALL = 'ALL'
};
export default Type;

